class PostFilterButtons {
    constructor(containerId) {
        this.containerId = containerId;
        this.$filterButtonsContainer = jQuery(`.mad-filter-buttons__container[data-posts-id='${this.containerId}']`);
        this.$filterButtons = this.$filterButtonsContainer.find('.mad-filter-buttons .filter-button');
        this.$postContainer = jQuery(`.mad-blog-posts__container[data-posts-id='${this.containerId}'] .mad-blog-posts`);

        this.init();
    }

    init() {
        // Attach event listeners to filter buttons
        this.$filterButtons.on('click', (event) => {
            const $button = jQuery(event.currentTarget);
            const filterValue = $button.data('filter');

            // Remove the active class from all buttons and add it to the clicked button
            this.$filterButtons.removeClass('active');
            $button.addClass('active');

            this.filterItems(filterValue);
        });
    }

    filterItems(filterValue) {
        const $items = this.$postContainer.find('.mad-blog-posts__post-container');

        if (filterValue === 'all') {
            // Remove the 'disabled' class from all items
            $items.removeClass('disabled');
        } else {
            // Add 'disabled' class to all items and remove it only from the filtered ones
            $items.addClass('disabled');
            $items.filter(function () {
                const $item = jQuery(this);
                const categories = $item.data('categories').split(' ');
                return categories.includes(filterValue);
            }).removeClass('disabled');
        }
    }
}

jQuery(document).ready(function () {
    // Initialize the filter buttons for each filter button container found on the page
    jQuery('.mad-filter-buttons__container').each(function () {
        const containerId = jQuery(this).data('posts-id');
        new PostFilterButtons(containerId);
    });
});
